module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Regular.4aedee69df0c2653d6f660d2c4d2a78c.woff2";